// extracted by mini-css-extract-plugin
export var container = "animated-keton-module--container--b381b";
export var ketonAnimation = "animated-keton-module--keton-animation--ad9b6";